var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.592 2.914a13.333 13.333 0 1114.815 22.172A13.333 13.333 0 016.592 2.914zm7.407 4.42a4 4 0 00-3.467 2 1.335 1.335 0 001.497 1.995 1.332 1.332 0 00.81-.662 1.333 1.333 0 011.16-.667 1.333 1.333 0 110 2.667A1.333 1.333 0 0012.666 14v1.333a1.333 1.333 0 102.666 0v-.24A4 4 0 0014 7.333zm-.947 11.053c-.057.063-.11.13-.16.2-.05.074-.09.155-.12.24a.855.855 0 00-.08.24 1.826 1.826 0 000 .266 1.12 1.12 0 00.107.507 1.2 1.2 0 00.72.72 1.252 1.252 0 001.013 0 1.199 1.199 0 00.72-.72c.06-.162.087-.334.08-.507a1.335 1.335 0 00-2.28-.946z",
    fill: "#FDBC22"
  })));
}
export default SvgAlert;